/**
 * Internal dependencies
 */
import WMUWCAddToCartBundle from "./add-to-cart-bundle";

/**
 * 
 */
const addToCartBundle = new WMUWCAddToCartBundle();